import { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import { Input as ChakraInput, InputProps as ChakraInputProps } from '@chakra-ui/react';

export const MASKS = {
  CPF: '999.999.999-99',
  CNPJ: '99.999.999/9999-99',
  CNS: '999.999.999.999.999',
  BIRTH_DATE: '99/99/9999',
  BRAZIL_PHONE: '(99) 9 9999-9999',
  BRAZIL_POSTAL_CODE: '99999-999',
  HOUR: '99:99',
  NUMBER_THREE_DIGITS: '999',
  NUMBER_FIVE_DIGITS: '99999',
  NUMBER_FIVE_DIGITS_DECIMAL: '99999.99',
  SIGTAP: '99.99.99.999-9',
};

interface MaskedInputProps extends ChakraInputProps {
  mask: string;
  maskChar?: string;
  isDisabled?: boolean;
}

// Wrapper com forwardRef para evitar warning de findDOMNode
// O problema está dentro do react-input-mask que usa findDOMNode internamente
// Esta é uma mitigação até que a biblioteca seja atualizada ou substituída
export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>((props, ref) => {
  return <ChakraInput as={InputMask} ref={ref} isDisabled={props.isDisabled} {...props} />;
});

MaskedInput.displayName = 'MaskedInput';
